import { render, staticRenderFns } from "./grxx_add.vue?vue&type=template&id=7901a204&"
import script from "./grxx_add.vue?vue&type=script&lang=js&"
export * from "./grxx_add.vue?vue&type=script&lang=js&"
import style0 from "./grxx_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports